import './styles.scss'

import { useTranslation } from 'react-i18next'
import { Col, Row } from 'antd'

import { parseHtml } from '@/libs/utils/common'

const ProductDescription = ({ anchorId = '', longDescription = '' }) => {
  const { t } = useTranslation()

  return (
    <div className="product-description__wrapper pt-4 pb-4">
      <Row>
        <Col>
          <h3 id={anchorId}>{t('productDetails.productDescription')}</h3>
          <div className="product-description__text mt-4">
            {parseHtml(
              longDescription?.replaceAll(/(?:<br(?: *\/)?>\s*)*$/gm, '') || '',
            )}
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default ProductDescription
